import {
  GET_SUB_PRACTICE_DETAIL,
  GET_SUB_PRACTICE_DETAIL_SUCCESS,
  GET_SUB_PRACTICE_DETAIL_FAILURE,
} from 'store/getSubPracticeDetail/getSubPracticeDetailAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getSubPracticeDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUB_PRACTICE_DETAIL:
      return { ...state, loading: true };
    case GET_SUB_PRACTICE_DETAIL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SUB_PRACTICE_DETAIL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getSubPracticeDetailReducer;
